<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable-->
<template>
    <section>
      <b-container class="container-small" :style="{ minHeight: minHeightStyle }">
        <b-card v-if="loading">
        <b-skeleton width="20%" class="mb-1" />
            <b-skeleton height="35px" class="mb-3" />
            <b-skeleton width="20%" class="mb-1" />
            <b-skeleton height="35px" class="mb-2" />
            <b-skeleton width="20%" class="mb-1" />
            <b-skeleton height="35px" class="mb-2" />
            <b-skeleton
              v-for="i in 4"
              :key="i"
              :width="i === 1 ? '40%' : '20%'"
              :class="i === 4 ? 'mb-2' : 'mb-1'"
            />
            <b-skeleton width="20%" class="mb-1" />
            <b-skeleton height="35px" class="mb-2" />
            <b-skeleton width="20%" class="mb-1" />
            <b-skeleton height="35px" class="mb-2" />
            <b-skeleton width="20%" class="mb-1" />
            <b-skeleton height="35px" class="mb-2" />
            <b-skeleton width="20%" class="mb-1" />
            <b-skeleton height="35px" class="mb-1" />
      </b-card>
        <b-card v-else class="mb-2" :style="{ minHeight: minHeightStyle }">
          <b-form-group
            class="mb-3"
            :label="$tk('ClientPortal.WhitelistBlacklist.Property') + ' *'"
            :invalid-feedback="errors['Property']"
          >
            <v-select
              v-model="propertyObject"
              :options="propertyOptions"
              label="name"
              taggable
              :clearable="false"
              select-on-tab
            />
          </b-form-group>
          <AccountsInput
          label="Whitelist"
          :accounts="accounts"
          @add="addWhiteList"
          @search="searchAccounts"
          />
          <SelectedItems
          v-if="selectedWhiteAccounts.length"
           :items="selectedWhiteAccounts"
            id-label="accountId"
            variant="avatar"
            :remove-by-item="true"
            @remove="removeWhiteList"
          />
          <AccountsInput
          label="Blacklist"
          :accounts="accounts"
          @add="addBlackList"
          @search="searchAccounts"
          />
          <SelectedItems
          v-if="selectedBlackAccounts.length"
           :items="selectedBlackAccounts"
            id-label="accountId"
            variant="avatar"
            :remove-by-item="true"
            @remove="removeBlackList"
          />
        </b-card>
      </b-container>
      <div v-if="!loading" class="border-top text-right py-1">
        <div class="container-small mx-auto">
          <b-button
            size="sm"
            class="bg-white ml-50"
            variant="primary"
            :disabled="saving || !isFormComplete"
            @click="saveAccountTargeting()"
          >
            {{ $tk("ClientPortal.Form.Actions.Save") }}
          </b-button>
        </div>
      </div>
    </section>
  </template>

<script>
import PropertiesService from '@/api/admin/properties.service'
import AccountsInput from '@/components/AccountsInput.vue'
import vSelect from 'vue-select'
import AccountPropertyTargetings from '@/api/admin/accountPropertiesTargetings.service'
import AccountsService from '@/api/admin/accountAdmin.service'
import SelectedItems from '@/components/SelectedItems.vue'
import notification from '@/mixins/toastification'

export default {
  components: {
    vSelect,
    AccountsInput,
    SelectedItems,
  },
  mixins: [notification],
  data() {
    return {
      propertyObject: {},
      saving: false,
      errors: {},
      loading: true,
      propertyOptions: [],
      accounts: [],
      selectedWhiteAccounts: [],
      selectedBlackAccounts: [],
      baseHeight: 500,
      showErrorModal: false,
      errorMessage: {},
    }
  },
  computed: {
    minHeightStyle() {
      const additionalHeight = (this.selectedWhiteAccounts.length + this.selectedBlackAccounts.length) * 50
      return `${this.baseHeight + additionalHeight}px`
    },
    isFormComplete() {
      const isPropertySelected = this.propertyObject && this.propertyObject.id
      const isAnyListNotEmpty = this.selectedWhiteAccounts.length > 0 || this.selectedBlackAccounts.length > 0
      return isPropertySelected && isAnyListNotEmpty
    },
  },
  async mounted() {
    await this.fetchProperties()
    await this.fetchAccounts()
  },
  methods: {
    async fetchProperties() {
      this.loading = true
      try {
        const properties = await PropertiesService.getAllProperties()
        this.propertyOptions = properties
      } catch (error) {
        console.error('Error fetching properties:', error)
      } finally {
        this.loading = false
      }
    },
    async fetchAccounts() {
      this.loading = true
      try {
        const accounts = await AccountsService.getAllAccounts('')
        this.accounts = accounts
      } catch (error) {
        console.error('Error fetching accounts', error)
      } finally {
        this.loading = false
      }
    },
    addWhiteList(selectedItem) {
      const existsInWhiteList = this.selectedWhiteAccounts.some(account => account.accountId === selectedItem.id)
      if (!existsInWhiteList) {
        const account = {
          id: 0,
          accountId: selectedItem.id,
          name: selectedItem.name,
          imageUrl: selectedItem.imageUrl,
        }
        this.selectedWhiteAccounts.push(account)
      }
    },
    removeWhiteList(item) {
      const index = this.selectedWhiteAccounts.findIndex(
        account => account.accountId === item.accountId,
      )
      this.selectedWhiteAccounts.splice(index, 1)
    },
    addBlackList(selectedItem) {
      const existsInBlackList = this.selectedBlackAccounts.some(account => account.accountId === selectedItem.id)
      if (!existsInBlackList) {
        const account = {
          id: selectedItem.id,
          accountId: selectedItem.id,
          name: selectedItem.name,
          imageUrl: selectedItem.imageUrl,
        }
        this.selectedBlackAccounts.push(account)
      }
    },
    removeBlackList(item) {
      const index = this.selectedBlackAccounts.findIndex(
        account => account.accountId === item.accountId,
      )
      this.selectedBlackAccounts.splice(index, 1)
    },
    async saveAccountTargeting() {
      this.saving = true
      const payload = this.formatAccountTargetingPayload()
      try {
        const response = await AccountPropertyTargetings.createProperty(payload)
        if (response.success) {
          this.success('Created Successfully')
          setTimeout(() => {
            this.$router.push('whitelist-blacklist')
          }, 2000)
        } else {
          response.errors.forEach(errorCode => {
            const accountId = parseInt(errorCode, 10)
            const account = this.accounts.find(acc => acc.id === accountId)
            this.error(`Property Account with name ${account.name} already exists`)
          })
        }
      } catch (err) {
        // eslint-disable-next-line prefer-destructuring
      } finally {
        this.saving = false
      }
    },
    formatAccountTargetingPayload() {
      const formattedWhiteList = this.selectedWhiteAccounts.map(account => ({
        PropertyId: this.propertyObject.id,
        Type: 1,
        AccountId: account.accountId,
        Status: 1,
      }))

      const formattedBlackList = this.selectedBlackAccounts.map(account => ({
        PropertyId: this.propertyObject.id,
        Type: 2,
        AccountId: account.accountId,
        Status: 1,
      }))

      return [...formattedWhiteList, ...formattedBlackList]
    },
    async searchAccounts(term) {
      try {
        if (term.length === 0) {
          this.accounts = await AccountsService.getAllAccounts('')
        } else {
          this.accounts = await AccountsService.getAllAccounts(term)
        }
      } catch (err) {
        this.error(err.message)
      }
    },
  },
}
</script>
  <style lang="scss" scoped>
  .multiselect-selected-image {
    max-width: 64px;
  }
  </style>
